import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <Helmet>
        <title>404 – Page Not Found | LoL Calculator</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="page-not-found">
        <div className="page-not-found-content">
          <div className="page-not-found-icon">404</div>
          <h1 className="page-not-found-title">Page Not Found</h1>
          <p className="page-not-found-message">
            The path "<span className="page-not-found-path">{location.pathname}</span>" doesn't exist.
          </p>
          <div className="page-not-found-actions">
            <button className="page-not-found-btn primary" onClick={() => navigate('/')}>
              Go Home
            </button>
            <button className="page-not-found-btn secondary" onClick={() => navigate(-1)}>
              Go Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
